import type { SVGProps } from "react";

export function HardHat(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M2 18h20" />
      <path d="M4 18v-6a8 8 0 0 1 16 0v6" />
      <path d="M12 10v8" />
      <path d="M8 12v6" />
      <path d="M16 12v6" />
    </svg>
  );
}
